module.exports = __webpack_public_path__ + "media/images/svg-icon/collapse-58a2da777e24161538fb194efc57a689.svg";